import { useEffect, useState, createRef } from "react"
import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"
import {
  Grid as DataTable,
  GridColumn as DataTableColumn,
} from "@progress/kendo-react-grid"

import ActionsCell from "./ActionsCell"
import { Input } from "@progress/kendo-react-inputs"

import { filterBy } from "@progress/kendo-data-query"
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs"
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export"

import { Button } from "@progress/kendo-react-buttons"

import { fetchApprovedUsers, updateApprovedUsers } from "../Services/ApiService"

export default function ManageUsers(props) {
  const { setAppBarTitle, backgroundProcessor, notificationCreate, appMode } = props

  const [refresh, setRefresh] = useState(false)

  useEffect(() => {
    const manageUsers = async () => {
      setAppBarTitle("Manage Users")

      const approvedUsers = await fetchApprovedUsers()

      let users = approvedUsers.data.approvedUsers

      if (appMode !== "Veolia") {
        users = users.filter((user) => user.value.type === appMode)
      }

      setGridData(users)
    }

    manageUsers()
  }, [refresh])

  const [gridData, setGridData] = useState([])
  const [orderControls, setOrderControls] = useState({
    skip: 0,
    take: 20,
  })

  const [showUser, setShowUser] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [backupUser, setBackupUser] = useState(null)
  const [editMode, setEditMode] = useState(true)

  const [gridDataState, gridChange] = useState(orderControls)
  const [filter, setFilter] = useState(null)

  const [page, setPage] = useState({
    skip: 0,
    take: 20,
  })

  const _exporter = createRef()
  const exportExcel = () => {
    if (_exporter.current) {
      _exporter.current.save()
    }
  }

  const handleGridDataStateChange = (e) => {
    gridChange(e.dataState)
  }

  const viewUser = async (e, dataItem) => {
    setSelectedUser(dataItem)
    setBackupUser(dataItem)
    setShowUser(true)
  }

  const closeHandler = async () => {
    setShowUser(false)
    setSelectedUser(null)
    setEditMode(true)
  }

  const deleteUserHandler = async () => {
    backgroundProcessor?.add()

    try {
      selectedUser.value.status = "DELETE"
      await updateApprovedUsers(selectedUser)

      setShowUser(false)
      notificationCreate({
        severity: "success",
        message: "User Deleted Succesfully",
      })
    } catch (error) {
      setShowUser(false)
      notificationCreate({
        severity: "error",
        message: "Error Submitting Request - Please Try Again",
      })
    }

    setRefresh(!refresh)
    backgroundProcessor?.remove()
  }

  const resetPasswordHandler = async (user) => {
    backgroundProcessor?.add()

    try {
      selectedUser.value.status = "RESET_PASSWORD"
      await updateApprovedUsers(selectedUser)

      setShowUser(false)
      notificationCreate({
        severity: "success",
        message: "User Password Reset",
      })
    } catch (error) {
      setShowUser(false)
      notificationCreate({
        severity: "error",
        message: "Error Submitting Request - Please Try Again",
      })
    }

    setRefresh(!refresh)
    backgroundProcessor?.remove()
  }

  const editUserInfo = async (e) => {
    const newValue = e.value

    let key = e.nativeEvent.srcElement.id

    let editedUser = selectedUser

    editedUser.value[key] = newValue

    setSelectedUser(editedUser)
    setRefresh(!refresh)
  }

  const cancelEdit = async () => {
    selectedUser.value.postcode = backupUser.value.postcode
    selectedUser.value.address = backupUser.value.address
    selectedUser.value.contactNumber = backupUser.value.contactNumber
    selectedUser.value.businessEmail = backupUser.value.businessEmail

    console.log(backupUser)
    setEditMode(true)
    setShowUser(false)

    setRefresh(!refresh)

    setSelectedUser(backupUser)

    setTimeout(() => {
      setShowUser(true)
    }, 1000)
  }

  const submitUserHandler = async () => {
    backgroundProcessor?.add()

    try {
      selectedUser.value.status = "UPDATE"
      await updateApprovedUsers(selectedUser)
      setEditMode(true)
      setShowUser(false)
      notificationCreate({
        severity: "success",
        message: "User Updated Succesfully",
      })
    } catch (error) {
      setEditMode(true)
      setShowUser(false)
      notificationCreate({
        severity: "error",
        message: "Error Submitting Request - Please Try Again",
      })
    }

    setRefresh(!refresh)
    backgroundProcessor?.remove()
  }

  const CommandCell = (props) => <ActionsCell {...props} viewUser={viewUser} />

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      style={{ paddingBottom: "1rem", backgroundColor: "lightgrey" }}
    >
      <Grid
        container
        item
        direction="column"
        alignItems="center"
        style={{ paddingBottom: "1rem", paddingTop: "2rem" }}
      >
        <Grid item>
          <h1>Manage Users</h1>
        </Grid>
      </Grid>

      <Grid container item direction="column" style={{ maxWidth: "95vw" }}>
        <Paper elevation={3} className="home-container">
          <Grid
            elevation={3}
            container
            style={{ paddingBottom: "0.3rem", paddingLeft: "1rem" }}
          >
            <Grid item>
              <Button
                onClick={exportExcel}
                style={{ backgroundColor: "#E95F47", color: "white" }}
              >
                Export to Excel <i className="fas fa-file-excel" />
              </Button>
            </Grid>
            <ExcelExport data={gridData} fileName="BidsUsers.xlsx" ref={_exporter}>
              <ExcelExportColumn
                field="value.name"
                title="Name"
                locked={true}
                width={250}
              />
              <ExcelExportColumn
                field="value.username"
                title="Username"
                width={250}
              />
              {appMode === "Veolia" && (
                <ExcelExportColumn field="value.type" title="System" width={250} />
              )}
              <ExcelExportColumn
                field="value.businessEmail"
                title="Email"
                width={350}
              />
              <ExcelExportColumn
                field="value.businessName"
                title="Company"
                width={350}
              />
              <ExcelExportColumn
                field="value.contactNumber"
                title="Contact No."
                width={350}
              />
            </ExcelExport>
          </Grid>
          <Grid container item direction="column">
            <Grid
              container
              item
              direction="column"
              alignItems="flex-start"
              style={{ paddingBottom: "1rem", paddingLeft: "1rem" }}
            >
              <Grid item>
                <DataTable
                  style={{ height: "100%", marginTop: "1rem", fontSize: "0.75rem" }}
                  data={filterBy(gridData, filter)}
                  pageable={true}
                  sortable={true}
                  total={gridData.length}
                  onDataStateChange={handleGridDataStateChange}
                  skip={page.skip}
                  take={page.take}
                  filterable={true}
                  filter={filter}
                  onFilterChange={(e) => setFilter(e.filter)}
                >
                  <DataTableColumn field="value.name" title="Name" />
                  <DataTableColumn field="value.username" title="Username" />
                  {appMode === "Veolia" && (
                    <DataTableColumn field="value.type" title="System" />
                  )}
                  <DataTableColumn
                    field="value.businessEmail"
                    title="Email"
                    width="300px"
                  />
                  <DataTableColumn field="value.businessName" title="Company" />
                  <DataTableColumn field="value.contactNumber" title="Contact No." />

                  <DataTableColumn
                    cell={CommandCell}
                    filterable={false}
                    title="Actions"
                    width="125px"
                  />
                </DataTable>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      {showUser && (
        <Dialog
          title={selectedUser.value.name}
          onClose={(e) => closeHandler()}
          height="65vh"
          width="50vw"
          style={{ border: "1px solid #E95F47" }}
        >
          <Grid
            container
            direction="column"
            alignItems="flex-start"
            style={{ marginTop: "1rem" }}
            spacing={4}
          >
            <Grid item className={"userDetails"}>
              <Input
                label={"Username:"}
                value={selectedUser.value.username}
                style={{ width: "50%" }}
                disabled={true}
              ></Input>
            </Grid>
            <Grid item className={"userDetails"}>
              <Input
                label={"Company:"}
                value={selectedUser.value.businessName}
                style={{ width: "50%" }}
                disabled={true}
              ></Input>
            </Grid>
            <Grid item className={"userDetails"}>
              <Input
                label={"Job Role:"}
                value={selectedUser.value.jobRole}
                style={{ width: "50%" }}
                disabled={true}
              ></Input>
            </Grid>
            <Grid item className={"userDetails"}>
              <Input
                label={"Email:"}
                id="businessEmail"
                name="businessEmail"
                value={selectedUser.value.businessEmail}
                style={{ width: "50%" }}
                onChange={(e) => editUserInfo(e)}
                disabled={editMode}
              ></Input>
            </Grid>
            <Grid item className={"userDetails"}>
              <Input
                label={"Contact No:"}
                id="contactNumber"
                name="contactNumber"
                value={selectedUser.value.contactNumber}
                style={{ width: "50%" }}
                onChange={(e) => editUserInfo(e)}
                disabled={editMode}
              ></Input>
            </Grid>
            <Grid item className={"userDetails"}>
              <Input
                label={"Address:"}
                id="address"
                name="address"
                value={selectedUser.value.address}
                style={{ width: "50%" }}
                onChange={(e) => editUserInfo(e)}
                disabled={editMode}
              ></Input>
            </Grid>
            <Grid item className={"userDetails"}>
              <Input
                label={"Postcode:"}
                id="postcode"
                name="postcode"
                value={selectedUser.value.postcode}
                style={{ width: "50%" }}
                onChange={(e) => editUserInfo(e)}
                disabled={editMode}
              ></Input>
            </Grid>
          </Grid>
          <DialogActionsBar>
            {editMode === true ? (
              <>
                <Button
                  style={{ backgroundColor: "#E95F47", color: "white" }}
                  onClick={(e) => resetPasswordHandler(selectedUser)}
                >
                  <i className="fas fa-key"> </i> Reset Password
                </Button>
                <Button
                  style={{ backgroundColor: "#E95F47", color: "white" }}
                  onClick={(e) => setEditMode(false)}
                >
                  <i className="fas fa-user-edit"> </i> Edit User
                </Button>
                <Button
                  style={{ backgroundColor: "#E95F47", color: "white" }}
                  onClick={(e) => deleteUserHandler(selectedUser)}
                >
                  <i className="fas fa-user-times"> </i> Delete User
                </Button>
              </>
            ) : (
              <>
                <Button
                  style={{ backgroundColor: "#E95F47", color: "white" }}
                  onClick={(e) => cancelEdit()}
                >
                  <i className="fas fa-ban"> </i> Cancel
                </Button>
                <Button
                  style={{ backgroundColor: "#E95F47", color: "white" }}
                  onClick={(e) => submitUserHandler()}
                >
                  <i className="fas fa-check-circle"> </i> Confirm
                </Button>
              </>
            )}
          </DialogActionsBar>
        </Dialog>
      )}
    </Grid>
  )
}
